import { GetPaymentResultDTO } from '../../api/@types/GetPaymentResultDTO';

export function getFuturePaymentsAfterDate(payments: GetPaymentResultDTO[], date: string, count: number): GetPaymentResultDTO[] {
  return payments
    .filter(payment => new Date(payment.plannedOnDateUTC) > new Date(date))
    .slice(0, count); 
}